import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import httpService from "../../../services/http.service";
import moment from "moment";
import { getUserFullName } from "../../../utils";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";

const WalletDetails = ({ match }) => {
    const { t } = useTranslation();
  const { id } = match.params;

  const [data, setData] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [status, setStatus] = useState("");
  const [rejectReason, setRejectReason] = useState("");

  const fetchData = async () => {
    try {
      const response = await httpService.get(`/wallets/${id}`);
      const data = response.data?.data;
      console.log(data);
      setData(data);
      setStatus(data?.document_status || "");
      setRejectReason(data?.document_rejection_reason);
    } catch (error) {
      console.error("Erreur chargement paiement:", error);
    } finally {
      setFetching(false);
    }
  };

  const updateWalletStatus = async () => {
    const confirm = window.confirm(
      i18n.t("Es-tu sûr de vouloir mettre à jour le statut de ce portefeuille ?")
    );
    if (!confirm) return;

    if (status === "rejected" && !rejectReason) {
      alert(t("Veuillez préciser la raison du rejet."));
      return;
    }

    try {
      setUpdating(true);
      await httpService.put(`/wallets/${data.id}`, {
        document_status: status,
        document_rejection_reason:  rejectReason,
      });
      alert(t("Wallet mis à jour avec succès"));
      fetchData();
    } catch (error) {
      alert(t("Erreur lors de la mise à jour du statut"));
      console.error(error);
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  if (fetching) return <FecthingSpinner />;

  if (!data)
    return (
      <div className="container-fluid">
        <AppBreadcrumb title={t("Détail du paiement")} />
        <div className="alert alert-danger mt-2">{t("Transaction introuvable.")}</div>
      </div>
    );

  return (
    <div className="container-fluid">
      <AppBreadcrumb title={t("Détail du paiement")} />
      <div className="card p-4 bg-white text-dark">
        <h5 className="mb-4 text-secondary">{t("Détails du paiement")}</h5>
        <div className="row">
          {/* User Info */}
          <div className="col-md-4 text-center">
            <img
              src={data?.method?.method_logo || MyOpinionLogo}
              className="rounded-circle mb-2"
              width="80"
              height="80"
              alt="User"
              style={{ objectFit: "cover" }}
            />
            <h6 className="mb-1">{data?.method?.method_name}</h6>
            {/* <h6 className="mb-1">{getUserFullName(data?.user, true)}</h6>
            <p className="text-muted mb-4">@{data?.user?.user_username}</p> */}

            <hr></hr>
            <label className="form-label d-block mb-3">
              Statut:{" "}
              <span
                className={`badge ${
                  data.document_status === "approved"
                    ? "badge-success"
                    : data.document_status === "pending"
                    ? "badge-outline-secondary"
                    : "badge-danger"
                }`}
              >
                {data.document_status}
              </span>
            </label>
            <select
              className="form-control mb-3"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              disabled={updating}
            >
              <option value="pending">{t("En attente")}</option>
              <option value="approved">{t("Approuvé")}</option>
              <option value="rejected">{t("Rejeté")}</option>
            </select>

            {status === "rejected" && (
              <div className="mb-3 text-left">
                <label className="form-label">{t("Cause du rejet")}</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder={t("Expliquez la cause du rejet...")}
                  disabled={updating}
                />
              </div>
            )}

            <button
              className="btn btn-primary btn-block"
              onClick={updateWalletStatus}
              disabled={updating}
            >
              {updating ? i18n.t("Mise à jour...") : i18n.t("Mettre à jour")}
            </button>
          </div>

          {/* Payment Info */}
          <div className="col-md-8">
            <div className="row mb-2">
              <div className="col-md-6">
                <p className="mb-1 text-muted">{t("Utilisateur")}</p>
                <p className="font-weight-bold">
                  {getUserFullName(data?.user, true)}
                </p>
              </div>

              <div className="col-md-6">
                <p className="mb-1 text-muted">{t("Pays")}</p>
                <p className="font-weight-bold">{data.country.name_fr}</p>
              </div>

              {(data.account_branch || data.bank_code) && (
                <div className="col-md-6">
                  <p className="mb-1 text-muted">{t("Code banque")}</p>
                  <p className="font-weight-bold">
                    {data.account_branch ? (
                      <td>{data.account_branch || "-"}</td>
                    ) : (
                      <td>{data.bank_code || "-"}</td>
                    )}
                  </p>
                </div>
              )}
              <div className="col-md-6">
                <p className="mb-1 text-muted">
                  {data.account_number ? (
                    <td> {t("No. compte")}</td>
                  ) : (
                    <td> {t("Identifiant du compte")}</td>
                  )}
                </p>

                <p className="font-weight-bold">
                  {data.account_number ? (
                    <td>{data.account_number || "-"}</td>
                  ) : (
                    <td>{data.account_id || "-"}</td>
                  )}
                </p>
              </div>

              <div className="col-md-6">
                <p className="mb-1 text-muted">{t("Bénéficiaire")}</p>
                <p className="font-weight-bold">{data.full_name}</p>
              </div>

              <div className="col-md-6">
                <p className="mb-1 text-muted">{t("Téléphone")}</p>
                <p className="font-weight-bold">{data.phone}</p>
              </div>

              <div className="col-md-6">
                <p className="mb-1 text-muted">{t("Date")}</p>
                <p className="font-weight-bold">
                  {moment(data.created_at).format("DD/MM/YYYY HH:mm")}
                </p>
              </div>
              <div className="row col-md-12">
                <div className="col-md-6">
                  <p className="mb-1 text-muted">{t("Document recto")}</p>
                  <p className="font-weight-bold">
                    <img
                      src={data?.document_recto || MyOpinionLogo}
                      className="rounded border"
                      width="250"
                      height="150"
                      alt="User"
                      style={{ objectFit: "cover" }}
                    />
                  </p>
                </div>

                <div className="col-md-6">
                  <p className="mb-1 text-muted">{t("Document verso")}</p>
                  <p className="font-weight-bold">
                    <img
                      src={data?.document_verso || MyOpinionLogo}
                      className="rounded border"
                      width="250"
                      height="150"
                      alt="User"
                      style={{ objectFit: "cover" }}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletDetails;
